import { FormattedMessage } from 'components/shared/Intl';
import type { TagOption } from 'components/shared/Tags/model';
import type { Underlying } from 'models/underlying';
import { FC } from 'react';
import type { NoticeProps } from 'react-select';

import type { UnderlyingResultTableProps } from './Common';

export const NoOptionsResultPanel: FC<UnderlyingResultTableProps> = ({ children }) => {
  return <>{children}</>;
};

export function NoOptionsMessage(_: NoticeProps<TagOption<Underlying>, boolean>) {
  return (
    <div className="underlying-line" data-e2e="underlying-no-result">
      <FormattedMessage id="noDataAvailable" />
    </div>
  );
}
